<template>
    <form @submit.prevent="submit">
        <div class="bg-white py-6 px-4 space-y-6 sm:p-6">
            <div>
                <h2 id="payment_details_heading" class="text-lg leading-6 font-medium text-gray-900">
                    {{ $t('gestion.integration.mailchimp.title') }}
                </h2>
                <p class="mt-1 text-sm leading-5 text-gray-500">
                    {{ $t('gestion.integration.mailchimp.subtitle') }}
                </p>
            </div>
            <div class="grid grid-cols-4 gap-6">
                <ui-input
                    name="text"
                    :label="$t('gestion.integration.mailchimp.text')"
                    class="col-span-4"
                    v-model="integration.text"
                >
                    <div class="text-sm text-red-500" v-if="integration.errors.text">
                        {{ $t(integration.errors.text[0]) }}
                    </div>
                </ui-input>
                <ui-input
                    name="api_key"
                    :label="$t('gestion.integration.mailchimp.api_key')"
                    class="col-span-4"
                    v-model="integration.meta.api_key"
                >
                    <div class="text-sm text-gray-600">
                        {{ $t('gestion.integration.mailchimp.api_key_info') }}
                    </div>
                    <div class="text-sm text-red-500 mt-2" v-if="integration.errors['meta.api_key']">
                        {{ $t(integration.errors['meta.api_key'][0]) }}
                    </div>
                </ui-input>
                <ui-input
                    name="audience_id"
                    :label="$t('gestion.integration.mailchimp.audience_id')"
                    class="col-span-4"
                    v-model="integration.meta.audience_id"
                >
                    <div class="text-sm text-gray-600">
                        {{ $t('gestion.integration.mailchimp.audience_id_info') }}
                    </div>
                    <div class="text-sm text-red-500 mt-2" v-if="integration.errors['meta.audience_id']">
                        {{ $t(integration.errors['meta.audience_id'][0]) }}
                    </div>
                </ui-input>
            </div>
        </div>
        <div class="px-4 py-3 bg-gray-50 text-right flex justify-end sm:px-6">
            <span class="inline-flex rounded-md shadow-sm">
                <activix-button :loading="integration.processing" color="indigo" type="submit">
                    {{ submitText }}
                </activix-button>
            </span>
        </div>
    </form>
</template>

<script>
    import ActivixButton from '@/components/ui/ActivixButton.vue';
    import UiInput from '@/components/ui/UiInput.vue';

    export default {
        components: {
            UiInput,
            ActivixButton,
        },

        props: {
            initialIntegration: {
                type: Object,
                default: () => {},
            },
            submitText: {
                type: String,
                default: 'Save',
            },
        },

        data: (vm) => ({
            integration: vm.$inertia.form({ text: vm.$t('gestion.integration.mailchimp.default_text'), meta: { api_key: '', audience_id: '' }, ...vm.initialIntegration?.pivot }),
        }),

        watch: {
            initialIntegration() {
                if (Object.keys(this.$page.props.errors).length) {
                    return;
                }

                this.integration = this.$inertia.form({ text: '', meta: { api_key: '', audience_id: '' }, ...this.initialIntegration?.pivot });
            },
        },

        methods: {
            submit() {
                this.integration.transform((data) => ({
                    ...data,
                    integration_id: 1,
                })).put(this.$route(), {
                    onSuccess: () => this.$emit('updated'),
                });
            },
        },
    };
</script>
